export const getInitialState = () => ({
    fetchStatus: "initial",
    flexibleDateMinPrice: [],
    error: undefined
});
